import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './EmailVerifyBanner.css';

const DISMISS_KEY = 'imoney_email_banner_dismissed_at';
const DISMISS_TTL_MS = 3 * 24 * 60 * 60 * 1000; // ปิดแล้วเงียบ 3 วัน ค่อยเตือนใหม่

function wasRecentlyDismissed() {
    try {
        const at = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
        return at && (Date.now() - at) < DISMISS_TTL_MS;
    } catch (e) {
        return false;
    }
}

export default function EmailVerifyBanner() {
    const { user } = useAuth();
    const location = useLocation();
    const [dismissed, setDismissed] = useState(wasRecentlyDismissed());

    // ไม่แสดงถ้า: ยังไม่ login / ยืนยันอีเมลแล้ว / เพิ่งกดปิด / อยู่หน้าโปรไฟล์อยู่แล้ว
    if (!user) return null;
    if (user.email_verified) return null;
    if (dismissed) return null;
    if (location.pathname.startsWith('/profile')) return null;

    const hasEmail = !!user.email;

    const handleDismiss = () => {
        try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) {}
        setDismissed(true);
    };

    return (
        <div className="email-verify-banner">
            <div className="evb-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                </svg>
            </div>
            <div className="evb-text">
                <strong>
                    {hasEmail ? 'อีเมลของคุณยังไม่ได้ยืนยัน' : 'เพิ่มอีเมลเพื่อความสะดวกในอนาคต'}
                </strong>
                <span>
                    {hasEmail
                        ? 'ยืนยันอีเมลเพื่อใช้รับ-ส่งเอกสาร รับการแจ้งเตือน และกู้คืนรหัสผ่านได้ในอนาคต'
                        : 'เพิ่มและยืนยันอีเมลของคุณ เพื่อใช้รับ-ส่งเอกสาร รับการแจ้งเตือน และกู้คืนรหัสผ่านได้ในอนาคต'}
                </span>
            </div>
            <Link to="/profile#email" className="evb-action">
                {hasEmail ? 'ยืนยันอีเมล' : 'เพิ่มอีเมล'}
            </Link>
            <button type="button" className="evb-close" onClick={handleDismiss} aria-label="ปิด" title="ปิด (เตือนอีกครั้งภายหลัง)">
                &times;
            </button>
        </div>
    );
}
